(() => {
  const drawerSelector = '#Product-Drawer';
  const coverSelector = `${drawerSelector} .product-single__media-video-cover`;
  const playerSelector = '.quick-view-media-player';

  function pausePlayer(player) {
    if (player.matches('video')) {
      player.pause();
      return;
    }

    if (!player.matches('iframe')) return;

    try {
      player.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'pauseVideo',
        args: ''
      }), '*');
    } catch (error) {}

    try {
      player.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
    } catch (error) {}
  }

  function pauseInactivePlayers(drawer, activeSlide = null) {
    drawer.querySelectorAll(playerSelector).forEach((player) => {
      if (!activeSlide || !activeSlide.contains(player)) pausePlayer(player);
    });
  }

  function playInlineVideo(cover) {
    const drawer = cover.closest(drawerSelector);
    const media = cover.closest(
      '.product-single__media-native-video, .product-single__media-external-video'
    );
    if (!drawer || !media) return;

    pauseInactivePlayers(drawer, media.closest('.product-images__slide'));

    let player = media.querySelector(playerSelector);
    if (!player) {
      const template = media.querySelector('.product-media__video-template');
      const templatePlayer = template && template.content.querySelector('video, iframe');
      if (!templatePlayer) return;

      player = templatePlayer.cloneNode(true);
      player.classList.add('quick-view-media-player');

      if (player.matches('iframe') && !player.title) {
        player.title = cover.querySelector('.product-media-play-btn')?.ariaLabel || 'Product video';
      }

      media.appendChild(player);
      media.classList.add('quick-view-video-active');
    }

    if (player.matches('video')) {
      player.play().catch(() => {});
    }
  }

  // Capture the click before the PDP PhotoSwipe handler. Quick View plays video
  // inside the drawer; PDP media retains its existing lightbox behavior.
  document.addEventListener('click', (event) => {
    const cover = event.target.closest(coverSelector);
    if (!cover) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    playInlineVideo(cover);
  }, true);

  document.addEventListener('quick-view:open', () => {
    // Quick View reinitializes Flickity on its next animation frame. Bind after
    // that reinitialization so videos pause when another media slide is shown.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const drawer = document.querySelector(drawerSelector);
        const slider = drawer && drawer.querySelector('#Product-Slider');
        if (!drawer || !slider || !slider.flkty) return;

        slider.flkty.on('change', (index) => {
          const slides = slider.querySelectorAll('.product-images__slide.is-active');
          pauseInactivePlayers(drawer, slides[index] || null);
        });
      });
    });
  });

  document.addEventListener('panel:closed', (event) => {
    const panel = event.detail && event.detail.panel;
    if (panel && panel.matches(drawerSelector)) pauseInactivePlayers(panel);
  });
})();
